import { Box } from "@mui/material"
import type { FC } from "react"

import { SoftReceivedPurchaseOrderForm } from "../SoftReceivedPalletRowForm"

import type { GoodsReceipt } from "@/graphql/codegen/graphql"

interface GoodsReceiptPalletsCreateFormProps {
  goodsReceipt: GoodsReceipt
}

export const GoodsReceiptPalletsCreateForm: FC<GoodsReceiptPalletsCreateFormProps> = ({ goodsReceipt }) => {
  const purchaseOrders = goodsReceipt.orders ?? []
  const goodsReceiptLines = goodsReceipt.productDetails ?? []

  return (
    <Box className='flex flex-col gap-y-4'>
      {purchaseOrders.map((purchaseOrder, purchaseOrderIndex) => (
        <SoftReceivedPurchaseOrderForm
          key={purchaseOrder.orderId}
          purchaseOrder={purchaseOrder}
          purchaseOrderIndex={purchaseOrderIndex}
          goodsReceiptLines={goodsReceiptLines}
          isSubtotalsVisible={false}
        />
      ))}
    </Box>
  )
}
